<template>
  <Transition name="modal">
    <div
      v-show="show"
      class="modal-mask"
      @click="clickOutside"
    >
      <div
        class="modal-container relative"
        :style="containerStyle"
        @click.stop
      >
        <span
          v-show="showCloseIcon"
          class="absolute pin-t pin-r pt-4 px-4"
          @click="close"
        >
          <svg
            class="h-8 w-8 text-grey hover:text-grey-darkest"
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title v-text="'Close'" />
            <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
          </svg>
        </span>
        <header
          v-if="$slots['header']"
          class="text-center pb-4 border-b border-grey"
        >
          <h3 class="my-0 font-bold">
            <slot name="header" />
          </h3>
        </header>
        <slot />
        <div
          v-if="$slots['body']"
          class="modal-body text-center pt-4"
        >
          <slot name="body" />
        </div>
        <div
          v-if="$slots['confirm'] || $slots['cancel']"
          class="modal-footer text-center my-6"
        >
          <slot name="confirm">
            <button
              type="button"
              class="btn"
              @click="$emit('confirm')"
              v-text="'Confirm'"
            />
          </slot>
          <slot name="cancel">
            <button
              type="button"
              class="ml-4"
              @click="close"
              v-text="'Cancel'"
            />
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script type="text/babel">
export default {
  name: 'BaseModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    preventBackgroundScrolling: {
      type: Boolean,
      required: false,
      default: true,
    },
    clickOutsideToClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    overflowVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    containerStyle() {
      return this.overflowVisible ? { overflow: 'visible' } : {}
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.preventBackgroundScrolling && document.body.style.setProperty('overflow', 'hidden')
        } else {
          this.preventBackgroundScrolling && document.body.style.removeProperty('overflow')
        }
      },
    },
  },
  created() {
    if (this.clickOutsideToClose) {
      const escapeHandler = (e) => {
        if (e.key === 'Escape' && this.show) {
          this.close()
        }
      }

      document.addEventListener('keydown', escapeHandler)

      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', escapeHandler)
      })
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    clickOutside() {
      if (this.clickOutsideToClose) {
        this.close()
      }
    },
  },
}
</script>
